import { FormConfig, Validator } from '@topdanmark-onlinesolutions/claim-form-types';
import { getElementFromElementId } from './getElementFromElementId';

export const isRequired = (formConfig: FormConfig | undefined, elementId: string): boolean => {
    if (formConfig === undefined) {
        return false;
    }

    const element = getElementFromElementId(formConfig, elementId);
    const { validators } = element;

    let isRequiredField = false;

    validators.forEach((validator: Validator) => {
        const { type } = validator;
        if (type === 'notEmpty') {
            isRequiredField = true;
        }
        if (type === 'minItemsChecked') {
            isRequiredField = true;
        }
        if (type === 'dropdownChosen') {
            isRequiredField = true;
        }
        if (type === 'phone') {
            isRequiredField = true;
        }
        if (type === 'email') {
            isRequiredField = true;
        }
    });

    return isRequiredField;
};
